// Configuración de métodos de pago habilitados/deshabilitados
const paymentMethods = {
  visa: true,
  mastercard: false,
  webpay: true,
  getnet: false,
  khipu: false,
};

// Porcentajes de comisión por método de pago (aplicados a nivel global del sistema)
export const paymentCommissions = {
  Webpay: 2.9,    // 2.9% para Webpay (tarjeta de crédito/débito)
  Getnet: 3.5,    // 3.5% para Getnet (tarjeta de crédito/débito)
  Khipu: 2.5,     // 2.5% para Khipu (transferencia)
};

export default paymentMethods;
